var BrowserManager = new function () {
    this.Delayer = function () {
        window.location = "default.aspx"
    };
    this.ParentBack = function () { parent.history.back(); };
    this.Back = function () { history.go(-1); };
    this.Print = function () { window.print(); };
    this.SetTimeZoneOffSet = function (theControlName) {
        var now = new Date();
        var utc = document.getElementById(theControlName);
        if (utc != null) {
            utc.value = now.getTimezoneOffset().toString();
        }
    };
    this.ClickButton = function (theButtonName) {
        var btn = document.getElementById(theButtonName);
        btn.click();
    };
    this.ParentNavigateTo = function (theURL) {
        parent.window.location.href = theURL;
    };
    this.NavigateTo = function (theURL) {
        window.location.href = theURL;
    };
    this.Replace = function (theURL) {
        window.location.replace(theURL);
    };
    this.Print = function () {
        window.print();
    };
    this.Close = function () {
        var oWindow = PopupManager.GetRadWindowHandle();
        if (oWindow == null) {
            window.close();
        }
        else {
            oWindow.Close();
        }
    };
    this.SetInnerHTML = function (theControlName, theMessage) {
        var actionMessage = document.getElementById(theControlName);
        if (actionMessage != null) {
            actionMessage.innerHTML = theMessage;
        }
    };
}